import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import CategorySelect from "./CategorySelect";
import StaffSelect from "./StaffSelect";
import ImageUploader from "./ImageUploader";
import FormTextField from "../../../../../components/FormTextField";
import FormCheckbox from "../../../../../components/FormCheckbox";
import { useUser } from "src/business-types/grocery/components/UserContext";
import { normalizeFoodTypes } from "src/shared/utils/normalizeFoodTypes";

const EditProductFields = ({
  businessType,
  formData,
  handleNameChange,
  handleArabicNameChange,
  handleAmountChange,
  handleAmountBlur,
  handleInputChange,
  handleFileChange,
  handleKeyPress,
  refs,
  categories,
  staffList,
  previewImage,
  amountError,
}: any) => {
  const { userConfigration } = useUser();
  // Just update product name directly (no category initials)
  const handleProductNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleNameChange(e);
  };

    // Normalize food types from user configuration
    const foodTypes = userConfigration?.foodTypes 
      ? normalizeFoodTypes(userConfigration.foodTypes)
      : ["Veg", "Non-Veg"];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 2 }}>
      {/* Product Name */}
      <FormTextField
        id='productName'
        label='Product Name'
        required
        value={formData.productName}
        onChange={handleProductNameChange}
        onKeyDown={(e) => handleKeyPress(e, refs.productAmountRef)}
      />

      {/* Arabic Name */}
      <FormTextField
        id='arabicName'
        label='Arabic Name'
        required
        value={formData.arabicName}
        onChange={handleArabicNameChange}
        onKeyDown={(e) => handleKeyPress(e, refs.productAmountRef)}
        sx={{ direction: "ltr" }}
      />

      {/* Product Price */}
      <FormTextField
        id='amount'
        label='Product Price'
        required
        type='number'
        value={formData.amount}
        onChange={handleAmountChange}
        onBlur={handleAmountBlur}
        inputRef={refs.productAmountRef}
        onKeyDown={(e) => handleKeyPress(e, refs.selectCategoryRef)}
        error={formData.amount === "0" || parseFloat(formData.amount) < 0 || amountError}
        helperText={
          formData.amount === "0" 
            ? "Price must be greater than 0" 
            : parseFloat(formData.amount) < 0 
              ? "Price cannot be negative" 
              : amountError || ""
        }
      />

      {/* Restaurant Type */}
      {businessType === "Restaurant" && (
        <FormControl fullWidth variant='outlined'>
          <InputLabel id='type-label'>Type</InputLabel>
          <Select
            labelId='type-label'
            value={formData.type}
            onChange={(e) => handleInputChange("type", e.target.value as string)}
            label='Type'
            inputRef={refs.selectStaffRef}
          >
             {foodTypes.map((type: string) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Category */}
      <CategorySelect value={formData.categoryId} categories={categories} onChange={(value) => handleInputChange("categoryId", value)} />

      {/* Staff (only for Saloon) */}
      {businessType === "Saloon" && (
        <StaffSelect value={formData.staffIds} staffMembers={staffList} onChange={(value) => handleInputChange("staffIds", value)} />
      )}

      {/* Image Upload */}
      <ImageUploader value={formData.image} previewImage={previewImage} onChange={(file) => handleFileChange(file)} />

      {/* Inward Product Checkbox */}
      <FormCheckbox label='Its Inward Product' checked={formData.ownProduct} onChange={(e, checked) => handleInputChange("ownProduct", checked)} />
    </Box>
  );
};

export default EditProductFields;
